import script from "./BasicInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./BasicInfo.vue?vue&type=script&setup=true&lang=js"

import "./BasicInfo.vue?vue&type=style&index=0&id=39f5807c&lang=scss&scoped=true"

import exportComponent from "/builds/frontend/linjie/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39f5807c"]])

export default __exports__